module.exports = __webpack_public_path__ + "static/img/homepage-bg-xl.f098e6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage-bg-xl.svg
// module id = B+2D
// module chunks = 2